export interface BuildAlternateRowIdInput {
  tableId: string;
  anchorProductGroupNumber: number | null;
  productCode: string;
}

export function buildAlternateRowId({
  tableId,
  anchorProductGroupNumber,
  productCode,
}: BuildAlternateRowIdInput): string {
  const anchorId = anchorProductGroupNumber === null ? "root" : String(anchorProductGroupNumber);

  return `${tableId}:alternate:${anchorId}:${productCode}`;
}
